export const FETCH_ADMIN_CHAPTER_EDIT_REQUEST = "FETCH_ADMIN_CHAPTER_EDIT_REQUEST";
export const FETCH_ADMIN_CHAPTER_EDIT_SUCCESS = "FETCH_ADMIN_CHAPTER_EDIT_SUCCESS";
export const FETCH_ADMIN_CHAPTER_EDIT_FAILURE = "FETCH_ADMIN_CHAPTER_EDIT_FAILURE";